import type { ComponentType, SVGProps } from "react";
import {
  ArchiveBoxArrowDownIcon,
  ArrowsRightLeftIcon,
  DocumentDuplicateIcon,
  DocumentMagnifyingGlassIcon,
  DocumentTextIcon,
  PhotoIcon,
  ScissorsIcon
} from "@heroicons/react/24/outline";
import type { DocumentOperation } from "@xhalo/document-contracts";

export interface ToolDefinition {
  operation: DocumentOperation;
  path: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  tone: "red" | "green" | "blue" | "violet" | "orange" | "purple";
  local: boolean;
}

export const toolCatalog: readonly ToolDefinition[] = [
  { operation: "merge", path: "/tools/merge", icon: DocumentDuplicateIcon, tone: "red", local: true },
  { operation: "compress", path: "/tools/compress", icon: ArchiveBoxArrowDownIcon, tone: "green", local: false },
  { operation: "split", path: "/tools/split", icon: ScissorsIcon, tone: "blue", local: true },
  { operation: "pdf_to_docx", path: "/tools/pdf-to-word", icon: DocumentTextIcon, tone: "violet", local: false },
  { operation: "pdf_to_images", path: "/tools/pdf-to-images", icon: PhotoIcon, tone: "orange", local: true },
  { operation: "convert", path: "/tools/convert", icon: ArrowsRightLeftIcon, tone: "blue", local: true },
  { operation: "ocr", path: "/tools/ocr", icon: DocumentMagnifyingGlassIcon, tone: "purple", local: false }
] as const;

export function toolByOperation(operation: DocumentOperation): ToolDefinition {
  const tool = toolCatalog.find((candidate) => candidate.operation === operation);
  if (!tool) throw new Error(`Unknown document operation: ${operation}`);
  return tool;
}
